<template>
  <div class="separator-text">
    <span>{{ text }}</span>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: "",
    },
  },
};
</script>

<style>
.separator-text {
  color: #707070;
  display: flex;
  align-items: center;
  text-align: center;
  padding: 0px 12px;
  font-size: 11px;
}

.separator-text::before,
.separator-text::after {
  content: "";
  flex: 1;
  border-bottom: 2px solid #707070;
}

.separator-text:not(:empty)::before {
  margin-right: 8px;
}

.separator-text:not(:empty)::after {
  margin-left: 8px;
}
</style>